import { Switch, Table, TableColumnsType } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { svg } from "../../../Assets/svg";

const NotificationSettings = () => {
  const navigate = useNavigate();
  const [dataSource, setDataSource] = useState([
    { _id: "1", module: "Quotations", email: false, push_notification: false },
    { _id: "2", module: "Orders", email: false, push_notification: false },
  ]);

  const handleToggle = (
    id: string,
    field: "email" | "push_notification",
    value: boolean,
  ) => {
    const newData = dataSource.map((item) => {
      if (item._id === id) {
        return { ...item, [field]: value };
      }
      return item;
    });
    setDataSource(newData);
  };

  const columns: TableColumnsType<any> = [
    {
      title: "Module",
      dataIndex: "module",
      key: "module",
      width: "66%",
      render: (text) => <span className="fw-bold">{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "17%",
      render: (checked, record) => (
        <Switch
          checked={checked}
          onChange={(val) => handleToggle(record._id, "email", val)}
          style={{ backgroundColor: checked ? "#231F20" : "#949494" }}
          className="customSwitch"
        />
      ),
    },
    {
      title: "Push Notification",
      dataIndex: "push_notification",
      key: "push_notification",
      width: "17%",
      render: (checked, record) => (
        <Switch
          checked={checked}
          onChange={(val) => handleToggle(record._id, "push_notification", val)}
          style={{ backgroundColor: checked ? "#231F20" : "#949494" }}
          className="customSwitch"
        />
      ),
    },
  ];

  return (
    <div className="page-content h-100 px-40 py-40">
      <div className="mb-3 d-flex flex-column gap-md-2 gap-0">
        <div className="d-flex flex-md-nowrap flex-wrap gap-sm-3 justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3 order-md-1 order-1">
            <span
              onClick={() => navigate(-1)}
              className="svg-24 cursor-pointer text-dark"
              role="button"
              tabIndex={0}
              aria-label="Go back"
            >
              {svg?.backArrow}
            </span>
            <h2 className="text-black fs-36 fw-bolder page-title mb-0 order-md-1 order-1">
              <span>Notification Settings</span>
            </h2>
          </div>
        </div>
      </div>
      <div className="card page-table-card border-0 shadow rounded-4 overflow-y-auto mt-2">
        <div className="card-body overflow-y-auto" id="mainScrollDiv">
          <Table
            dataSource={dataSource}
            scroll={{ x: "max-content" }}
            columns={columns}
            rowKey={(record) => record._id}
            className="custom-table"
            bordered
            pagination={false}
            tableLayout="fixed"
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings;
